if (!customElements.get('multicolumn-wrapper')) {
  customElements.define(
    'multicolumn-wrapper',
    class MulticolumnWrapper extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          itemsWrap: '.multicolumn__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items) || 2;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
        this.paginationType = this.dataset.paginationType || 'progressbar';
        this.itemsWrap = this.querySelector(this.selectors.itemsWrap);

        this.sliderInstance = false;
        if (!this.enableSlider) return;

        if (!this.itemsWrap) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);

        const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
        mqlTablet.onchange = this.init.bind(this);

        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.itemsWrap).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.itemsWrap.classList.remove(this.classes.grid);
        this.itemsWrap.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();
        this.handleAccessibility();
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              if (element.closest('.swiper-slide')) {
                const slide = element.closest('.swiper-slide');
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== this.sectionId) return;
            const index = Number(e.target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.destroy();
          this.sliderInstance = false;
          this.classList.remove(this.classes.swiper);
          if (this.itemsWrap) {
            this.itemsWrap.classList.remove(this.classes.swiperWrapper);
            this.itemsWrap.classList.add(this.classes.grid);
          }
        }
      }
    }
  );
}

